
var $virtualMirrorObj = {};

$virtualMirrorObj.isVMSupported = false

var vmVersion, productVm, vmDir, chunkURL, itemBeanCatentry = [], regionBipa, vmjslib, initParams, vmPartnumberArr = [], safariScreenshot, disableOnBlur = false, isUPCSupported, vmUpcAvailability = {}, vmCatalogue;

/*! dom-to-image 10-06-2017 */
!function(a){"use strict";function b(a,b){function c(a){return b.bgcolor&&(a.style.backgroundColor=b.bgcolor),b.width&&(a.style.width=b.width+"px"),b.height&&(a.style.height=b.height+"px"),b.style&&Object.keys(b.style).forEach(function(c){a.style[c]=b.style[c]}),a}return b=b||{},g(b),Promise.resolve(a).then(function(a){return i(a,b.filter,!0)}).then(j).then(k).then(c).then(function(c){return l(c,b.width||q.width(a),b.height||q.height(a))})}function c(a,b){return h(a,b||{}).then(function(b){return b.getContext("2d").getImageData(0,0,q.width(a),q.height(a)).data})}function d(a,b){return h(a,b||{}).then(function(a){return a.toDataURL()})}function e(a,b){return b=b||{},h(a,b).then(function(a){return a.toDataURL("image/jpeg",b.quality||1)})}function f(a,b){return h(a,b||{}).then(q.canvasToBlob)}function g(a){"undefined"==typeof a.imagePlaceholder?v.impl.options.imagePlaceholder=u.imagePlaceholder:v.impl.options.imagePlaceholder=a.imagePlaceholder,"undefined"==typeof a.cacheBust?v.impl.options.cacheBust=u.cacheBust:v.impl.options.cacheBust=a.cacheBust}function h(a,c){function d(a){var b=document.createElement("canvas");if(b.width=c.width||q.width(a),b.height=c.height||q.height(a),c.bgcolor){var d=b.getContext("2d");d.fillStyle=c.bgcolor,d.fillRect(0,0,b.width,b.height)}return b}return b(a,c).then(q.makeImage).then(q.delay(100)).then(function(b){var c=d(a);return c.getContext("2d").drawImage(b,0,0),c})}function i(a,b,c){function d(a){return a instanceof HTMLCanvasElement?q.makeImage(a.toDataURL()):a.cloneNode(!1)}function e(a,b,c){function d(a,b,c){var d=Promise.resolve();return b.forEach(function(b){d=d.then(function(){return i(b,c)}).then(function(b){b&&a.appendChild(b)})}),d}var e=a.childNodes;return 0===e.length?Promise.resolve(b):d(b,q.asArray(e),c).then(function(){return b})}function f(a,b){function c(){function c(a,b){function c(a,b){q.asArray(a).forEach(function(c){b.setProperty(c,a.getPropertyValue(c),a.getPropertyPriority(c))})}a.cssText?b.cssText=a.cssText:c(a,b)}c(window.getComputedStyle(a),b.style)}function d(){function c(c){function d(a,b,c){function d(a){var b=a.getPropertyValue("content");return a.cssText+" content: "+b+";"}function e(a){function b(b){return b+": "+a.getPropertyValue(b)+(a.getPropertyPriority(b)?" !important":"")}return q.asArray(a).map(b).join("; ")+";"}var f="."+a+":"+b,g=c.cssText?d(c):e(c);return document.createTextNode(f+"{"+g+"}")}var e=window.getComputedStyle(a,c),f=e.getPropertyValue("content");if(""!==f&&"none"!==f){var g=q.uid();b.className=b.className+" "+g;var h=document.createElement("style");h.appendChild(d(g,c,e)),b.appendChild(h)}}[":before",":after"].forEach(function(a){c(a)})}function e(){a instanceof HTMLTextAreaElement&&(b.innerHTML=a.value),a instanceof HTMLInputElement&&b.setAttribute("value",a.value)}function f(){b instanceof SVGElement&&(b.setAttribute("xmlns","http://www.w3.org/2000/svg"),b instanceof SVGRectElement&&["width","height"].forEach(function(a){var c=b.getAttribute(a);c&&b.style.setProperty(a,c)}))}return b instanceof Element?Promise.resolve().then(c).then(d).then(e).then(f).then(function(){return b}):b}return c||!b||b(a)?Promise.resolve(a).then(d).then(function(c){return e(a,c,b)}).then(function(b){return f(a,b)}):Promise.resolve()}function j(a){return s.resolveAll().then(function(b){var c=document.createElement("style");return a.appendChild(c),c.appendChild(document.createTextNode(b)),a})}function k(a){return t.inlineAll(a).then(function(){return a})}function l(a,b,c){return Promise.resolve(a).then(function(a){return a.setAttribute("xmlns","http://www.w3.org/1999/xhtml"),(new XMLSerializer).serializeToString(a)}).then(q.escapeXhtml).then(function(a){return'<foreignObject x="0" y="0" width="100%" height="100%">'+a+"</foreignObject>"}).then(function(a){return'<svg xmlns="http://www.w3.org/2000/svg" width="'+b+'" height="'+c+'">'+a+"</svg>"}).then(function(a){return"data:image/svg+xml;charset=utf-8,"+a})}function m(){function a(){var a="application/font-woff",b="image/jpeg";return{woff:a,woff2:a,ttf:"application/font-truetype",eot:"application/vnd.ms-fontobject",png:"image/png",jpg:b,jpeg:b,gif:"image/gif",tiff:"image/tiff",svg:"image/svg+xml"}}function b(a){var b=/\.([^\.\/]*?)$/g.exec(a);return b?b[1]:""}function c(c){var d=b(c).toLowerCase();return a()[d]||""}function d(a){return a.search(/^(data:)/)!==-1}function e(a){return new Promise(function(b){for(var c=window.atob(a.toDataURL().split(",")[1]),d=c.length,e=new Uint8Array(d),f=0;f<d;f++)e[f]=c.charCodeAt(f);b(new Blob([e],{type:"image/png"}))})}function f(a){return a.toBlob?new Promise(function(b){a.toBlob(b)}):e(a)}function g(a,b){var c=document.implementation.createHTMLDocument(),d=c.createElement("base");c.head.appendChild(d);var e=c.createElement("a");return c.body.appendChild(e),d.href=b,e.href=a,e.href}function h(){var a=0;return function(){function b(){return("0000"+(Math.random()*Math.pow(36,4)<<0).toString(36)).slice(-4)}return"u"+b()+a++}}function i(a){return new Promise(function(b,c){var d=new Image;d.onload=function(){b(d)},d.onerror=c,d.src=a})}function j(a){var b=3e4;return v.impl.options.cacheBust&&(a+=(/\?/.test(a)?"&":"?")+(new Date).getTime()),new Promise(function(c){function d(){if(4===g.readyState){if(200!==g.status)return void(h?c(h):f("cannot fetch resource: "+a+", status: "+g.status));var b=new FileReader;b.onloadend=function(){var a=b.result.split(/,/)[1];c(a)},b.readAsDataURL(g.response)}}function e(){h?c(h):f("timeout of "+b+"ms occured while fetching resource: "+a)}function f(a){/*console.error(a),*/c("")}var g=new XMLHttpRequest;g.onreadystatechange=d,g.ontimeout=e,g.responseType="blob",g.timeout=b,g.open("GET",a,!0),g.send();var h;if(v.impl.options.imagePlaceholder){var i=v.impl.options.imagePlaceholder.split(/,/);i&&i[1]&&(h=i[1])}})}function k(a,b){return"data:"+b+";base64,"+a}function l(a){return a.replace(/([.*+?^${}()|\[\]\/\\])/g,"\\$1")}function m(a){return function(b){return new Promise(function(c){setTimeout(function(){c(b)},a)})}}function n(a){for(var b=[],c=a.length,d=0;d<c;d++)b.push(a[d]);return b}function o(a){return a.replace(/#/g,"%23").replace(/\n/g,"%0A")}function p(a){var b=r(a,"border-left-width"),c=r(a,"border-right-width");return a.scrollWidth+b+c}function q(a){var b=r(a,"border-top-width"),c=r(a,"border-bottom-width");return a.scrollHeight+b+c}function r(a,b){var c=window.getComputedStyle(a).getPropertyValue(b);return parseFloat(c.replace("px",""))}return{escape:l,parseExtension:b,mimeType:c,dataAsUrl:k,isDataUrl:d,canvasToBlob:f,resolveUrl:g,getAndEncode:j,uid:h(),delay:m,asArray:n,escapeXhtml:o,makeImage:i,width:p,height:q}}function n(){function a(a){return a.search(e)!==-1}function b(a){for(var b,c=[];null!==(b=e.exec(a));)c.push(b[1]);return c.filter(function(a){return!q.isDataUrl(a)})}function c(a,b,c,d){function e(a){return new RegExp("(url\\(['\"]?)("+q.escape(a)+")(['\"]?\\))","g")}return Promise.resolve(b).then(function(a){return c?q.resolveUrl(a,c):a}).then(d||q.getAndEncode).then(function(a){return q.dataAsUrl(a,q.mimeType(b))}).then(function(c){return a.replace(e(b),"$1"+c+"$3")})}function d(d,e,f){function g(){return!a(d)}return g()?Promise.resolve(d):Promise.resolve(d).then(b).then(function(a){var b=Promise.resolve(d);return a.forEach(function(a){b=b.then(function(b){return c(b,a,e,f)})}),b})}var e=/url\(['"]?([^'"]+?)['"]?\)/g;return{inlineAll:d,shouldProcess:a,impl:{readUrls:b,inline:c}}}function o(){function a(){return b(document).then(function(a){return Promise.all(a.map(function(a){return a.resolve()}))}).then(function(a){return a.join("\n")})}function b(){function a(a){return a.filter(function(a){return a.type===CSSRule.FONT_FACE_RULE}).filter(function(a){return r.shouldProcess(a.style.getPropertyValue("src"))})}function b(a){var b=[];return a.forEach(function(a){try{q.asArray(a.cssRules||[]).forEach(b.push.bind(b))}catch(c){console.log("Error while reading CSS rules from "+a.href,c.toString())}}),b}function c(a){return{resolve:function(){var b=(a.parentStyleSheet||{}).href;return r.inlineAll(a.cssText,b)},src:function(){return a.style.getPropertyValue("src")}}}return Promise.resolve(q.asArray(document.styleSheets)).then(b).then(a).then(function(a){return a.map(c)})}return{resolveAll:a,impl:{readAll:b}}}function p(){function a(a){function b(b){return q.isDataUrl(a.src)?Promise.resolve():Promise.resolve(a.src).then(b||q.getAndEncode).then(function(b){return q.dataAsUrl(b,q.mimeType(a.src))}).then(function(b){return new Promise(function(c,d){a.onload=c,a.onerror=d,a.src=b})})}return{inline:b}}function b(c){function d(a){var b=a.style.getPropertyValue("background");return b?r.inlineAll(b).then(function(b){a.style.setProperty("background",b,a.style.getPropertyPriority("background"))}).then(function(){return a}):Promise.resolve(a)}return c instanceof Element?d(c).then(function(){return c instanceof HTMLImageElement?a(c).inline():Promise.all(q.asArray(c.childNodes).map(function(a){return b(a)}))}):Promise.resolve(c)}return{inlineAll:b,impl:{newImage:a}}}var q=m(),r=n(),s=o(),t=p(),u={imagePlaceholder:void 0,cacheBust:!1},v={toSvg:b,toPng:d,toJpeg:e,toBlob:f,toPixelData:c,impl:{fontFaces:s,images:t,util:q,inliner:r,options:{}}};"undefined"!=typeof module?module.exports=v:a.domtoimage=v}(this);

/** Initializes VM and checks browser support */
function checkVMSupport(callback) {
	productVm =  JSON.parse(JSON.stringify(tealiumProducts));
	delete productVm[Object.keys(productVm)[0]].Sku;
	delete productVm[Object.keys(productVm)[0]].Category;
	delete productVm[Object.keys(productVm)[0]].Engraving;
	delete productVm[Object.keys(productVm)[0]].Status;
	delete productVm[Object.keys(productVm)[0]].Price;
	delete productVm[Object.keys(productVm)[0]].Type;
	delete productVm[Object.keys(productVm)[0]].ModelName;
	delete productVm[Object.keys(productVm)[0]].PriceFull;
	
	var dataToPush = {};
	dataToPush.Products = tealiumProducts;
	dataToPush.Products[Object.keys(productVm)[0]].Vm_IsBrowserSupported = '';
	dataToPush.Products[Object.keys(productVm)[0]].Vm_IsUpcSupported = '';	
	  vmjslib.initialize(
	    initParams
	  ).then(function(response){
	    if (response.supportedFeatures.webglRendering
	         && response.supportedFeatures.webcamAvailable
	         && response.supportedFeatures.webcamAccess
	         && response.supportedFeatures.wasmSupport) {
	    	dataToPush.Products[Object.keys(productVm)[0]].Vm_IsBrowserSupported = '1';
	      	isVMSupported = true;
			/** Workaround
			if (isPersol
					&& $.browser.name == "Safari"
					&& (window.mobilecheck() || window.tabletPortraitCheck())) {
				$('.fade-bipa').css('z-index','0');
			}
			*/
	    } else {
	    	console.error("browser not supported");
	    	isVMSupported = false;
	    	// analytics
	    	dataToPush.Products[Object.keys(productVm)[0]].Vm_IsBrowserSupported = '0';
	    	if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
	      		$("#btn-virtual-mirror").hide();
	      	}else{
	      		$( ".container-btn-dsk" ).hide();
	      	}
	    }
	    
	    if(isVMSupported){
	    	callback();
	    }else{
	    	if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
	      		$("#btn-virtual-mirror").hide();
	      	}else{
	      		$( ".container-btn-dsk" ).hide();
	      	}
	    }	    
	  }).catch(function(error) {
	    console.error(error, error.message);
	    if (error.type === "WebcamRejectedError") {
	      console.error("webcam not available");
	    } else if (error.message === "Browser Unsupported") {
	      console.error("browser not supported");
	    }
	    isVMSupported = false;
	    if(isVMSupported){
	    	callback();
	    }else{
	    	if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
	      		$("#btn-virtual-mirror").hide();
	      	}else{
	      		$( ".container-btn-dsk" ).hide();
	      	}
	    }
	  });
};


/** Inits VM Object in DOM */
function initVM(callback, nameBrand) {
	try {
		chunkURL = vmDir;
		//	Dynamically loading VM libs
		$.cachedScript(vmDir+"virtual-mirror-"+vmVersion+".js")
		  .done(function(script,textStatus) {
			vmjslib = (window.VirtualMirror ? window.VirtualMirror : window.luxottica_vm.VirtualMirror);// luxottica_vm for VM Version < 8 
			
			  var majorVersion = vmVersion.split('.')[0];
				
			   if(majorVersion<9){
				   vmCatalogue = window.luxottica_vm.VirtualMirrorCatalogue.build({
						key: vmKey
					}); 
			   }else{
				   vmCatalogue = window.VirtualMirrorCatalogue.build({
						key: vmKey
					}); 
			   }
			
		
			initParams = {
			  options: {
				  key: vmKey,
				  channel: "ecommerce",
				  brand: nameBrand,
				  locale: $('[lang]').attr('lang'),
				  storeId: WCParamJS.storeId,
			    useNativeWrapper: false,
			    analyticsConfig: {
			    	onInitializeSuccess:  function(upc) {
			    		if(typeof upc != 'undefined'){
				    		tealium_data2track.push({ 
				    			   'id' : 'VirtualMirror',
				    			   'Vm_Action' : 'InitializeSuccess',
				    			   'Products[$upc].Vm_IsUpcSupported': "1"
				    		});
			    		}
			    	},
			        onInitializeError:  function(source,code,details,upc) {
			        	tealium_data2track.push({ 
			    			   'id' : 'Error',
			    			   'Error_Source':source,
			    			   'Error_Code':code,
			    			   'Error_Details':details,
			    			   'Products[$upc].Vm_IsUpcSupported': "0"
			    		});
			        	vmSwitchOff(true);
			        },
			        onRequestWebcam: function() {
			        	tealium_data2track.push({ 
			    			   'id' : 'VirtualMirror',
			    			   'Vm_Action' : 'RequestWebcam'
			    		});
			        },
			        onWebcamAllowed: function() {
			        	tealium_data2track.push({ 
			    			   'id' : 'VirtualMirror',
			    			   'Vm_Action' : 'WebcamAllowed'
			    		});
			        },
			        onWebcamDenied: function() {
			        	vmSwitchOff(true);
			        	/*
			        	setTimeout(function() {
			        		$(".mirror-container-error:not(.allow-camera)").replaceWith($(".mirror-container-error.allow-camera").clone().removeClass("hide")[0]);
			        	}, 50);
			        	*/
			        	tealium_data2track.push({ 
			    			   'id' : 'Error',
			    			   'Error_Source':'User',
			    			   'Error_Code':'Vm - WebcamRejectedError',
			    			   'Error_Details':'webcam access was rejected by user',
			    			   'Products[$upc].Vm_IsUpcSupported': "0"
  				    		});
						
						$(".fade-bipa").hide();
			        },
			        onWebcamUnavailable: function() {
			        	tealium_data2track.push({ 
			    			   'id' : 'Error',
			    			   'Error_Source':'User',
			    			   'Error_Code':'Vm - WebcamNotFoundError',
			    			   'Error_Details':'webcam not found',
			    			   'Products[$upc].Vm_IsUpcSupported': "0"
			    		});
			        },
			        onMirrorRenderFailure:  function(upc) {
			        	tealium_data2track.push({ 
			    			   'id' : 'Error',
			    			   'Error_Source':'Client',
			    			   'Error_Code':'Vm - MountComponentError',
			    			   'Error_Details':'failed to mount component at divId: vm_target',
			    			   'Products[$upc].Vm_IsUpcSupported': "0"
			    		});
			        },
			        onMirrorWasmFailure:  function(upc) {
			        	tealium_data2track.push({ 
			    			   'id' : 'Error',
			    			   'Error_Source':'Client',
			    			   'Error_Code':'Vm - UnmountComponentError',
			    			   'Error_Details':'failed to mount component at divId: vm_target',
			    			   'Products[$upc].Vm_IsUpcSupported': "0"
			    		});
			        },
					onRender: function(upc) {
						tealium_data2track.push({ 
								'id' : 'VirtualMirror',
								'Vm_Action' : 'Render',
								Products:{
									[upc]: {
										Vm_IsUpcSupported: '1'
									} 
								}
					 	});
					},
					onGlassesOn: function(upc) {
						tealium_data2track.push({ 
								'id' : 'VirtualMirror',
								'Vm_Action' : 'FitGlasses',
					 	});
					},
			    }
			  }
			};
			
			addBipa(initParams);
			
			checkVMSupport(function() {
				
				for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
					itemBeanCatentry.push(productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1]);
				}
				var vmPartnumberArr = [$('#vm_box').attr('data-vm')];
		  	    $.when(all(itemBeanCatentry,vmCatalogue.isUpcSupported(...itemBeanCatentry)))
		  		  .then(function(results) {
		  			vmUpcAvailability = results.reduce(function(map, obj) {
		  			    map[obj.upc] = obj;
		  			    return map;
		  			},{});
		  			flagIsVMEnabled = true;
		  			var currentPartnumber;
		  			//in this way we take the current partnumber
		  			for(var i = 0; i < productDisplayJS.entitledItems.length; i++){
		     			if(productDisplayJS.entitledItems[i].catentry_id == productDisplayJS.changedCatEntryId ){
		     				currentPartnumber =productDisplayJS.entitledItems[i].seo_url.split('/')[productDisplayJS.entitledItems[i].seo_url.split('/').length-1];
		     			}
		     		}
		  			
		  			//IN THISWAY WE KNOW THE POSITION OF CURRENTPARTNUMBER IN RESULTS ARRAY
		  			var positionCurrentPartnumber;
		  			for(var i = 0; i < results.length; i++ ){
		  				if(results[i].upc == currentPartnumber){
		  					positionCurrentPartnumber = i;
		  					break;
		  				}
		  			}
		  			
		  			var dataToPush = {};
		  			dataToPush.Products = tealiumProducts;
		  			//Check if is vm enable for this product
		  			flagIsVMready = false;
		  			if(typeof positionCurrentPartnumber != 'undefined'){
		  				if(results[positionCurrentPartnumber].isAvailable()){
		  					flagIsVMready = true;
		  					if(isPersol || isOliver){
				  				if(productType == 'Accessories'){
				  					flagIsVMready = false;
				  				}
				  			}
		  				}
		  			}
					//	Handle visibility of VM on some events
		  			if(flagIsVMready){
		  				dataToPush.Products[Object.keys(productVm)[0]].Vm_IsUpcSupported = '1'; 
		  				
		  				if((window.mobilecheck() || window.tabletPortraitCheck()) && isPersol){
		  					$('.container-btn-mob').show();
		  					$('.container-btn-mob #btn-virtual-mirror-mob').removeClass('vmLoader');
		  				}else if((window.mobilecheck() || window.tabletPortraitCheck()) && isOliver){
		  					$('.container-btn').show();
		  					$('.container-btn #btn-virtual-mirror-mob').removeClass('vmLoader');
		  				}else if(isOliver){
		  					$('.container-btn').show();
		  					$('.container-btn #btn-virtual-mirror').removeClass('vmLoader');
		  				}else if(isVogue){
		  			  		$('.container-btn-dsk').removeClass('vmLoader');
		  			  	}else{
		  					$('.container-btn-dsk #btn-virtual-mirror-dsk').removeClass('vmLoader');		
		  				}
						
		  				vmHandleEventsOnPage();
						//	Original callback
						callback();
		  			}else{
						if(isOliver){
							$('.container-btn').hide();
						}else{
							$('.container-btn-dsk').hide();
							if($('.container-btn-mob').length>0){
								$('.container-btn-mob').hide();
							}
							
						}
						
						dataToPush.Products[Object.keys(productVm)[0]].Vm_IsUpcSupported = '0';
					
		  				var useCallback = false; 
		  				//In this way we know if at least one UPC is VM availability
		  				for(var i = 0; i < results.length; i++ ){
			  				if(results[i].isAvailable()){
			  					useCallback = true;
			  					break;
			  				}
			  			}
		  				if(useCallback){
		  					callback();
		  				}
		  			}
					  if(!vmUpcAvailability[Object.keys(productVm)[0]].isAvailable()){
						$("[data-espot-name='X_PDP_Editorial_VirtualMirror']").hide();
					  }else{
						$("[data-espot-name='X_PDP_Editorial_VirtualMirror']").show();
					  }
		  			var t1 = performance.now();
		  			console.log("Tealium push postponed by " + (t1 - t0) + " milliseconds.")
		  			
		  			pushDataToTealium(dataToPush);
					
		  		});
			});
		  })
		  .fail(function(jqxhr,settings,exception ) {
			console.error("-> error during vm init: "+event);
			flagIsVMEnabled = false;	// Disable VM if there is an error getting the script
			//	Original callback
			callback();
		});
	} catch(error) {
		console.error("-> error during vm init: "+error);
		flagIsVMEnabled = false;	// Disable VM if there is an error during initialization
		//	Original callback
		callback();
	}
}
/** Add new partnumbers on Ajax Load More / Filter Apply */
/*function vmAddNewUpcs() {
	if (vmjslib != undefined) {
		//	Saving allowed partnumbers
		let vmPartnumberArr = [];
		for (const product of window.productDetails.map.values()) {
			for (const subProduct of product.subProducts) {
				if (vmUpcAvailability[subProduct[1].partNumber] == undefined) {
					vmPartnumberArr.push(subProduct[1].partNumber);
				}
		        for (const sibling of subProduct[1].siblings.values()) {
		        	if (vmUpcAvailability[sibling.partNumber] == undefined) {
		        		vmPartnumberArr.push(sibling.partNumber);
		        	}
		        }
			}
		}
	    $.when(all(vmPartnumberArr,vmCatalogue.isUpcSupported(...vmPartnumberArr)))
		  .then(function(results) {
			  vmUpcAvailability = Object.assign(vmUpcAvailability, results.reduce(function(map, obj) {
			     map[obj.upc] = obj;
			     return map;
			  },{}));
		});
	}
}*/

function addBipa(initParams) {
	var privacyPolicyURL = "";
	var termsAndConditionsURL = "";
	var country = $("#country").attr('value');
	if (country == 'US') {
		regionBipa = 'US';
	}else{
		regionBipa = 'EU';
	}
	$.getScript((isInToolkit ? '' : WCParamJS.urlPrefixForHTTPS)+"/wcsstore/Common/ThirdPartyLibraries/niceScroll/jquery.nicescroll.min.js");
	if (isOliver) {
		privacyPolicyURL = WCParamJS.homePageURL+'/privacy-policy1';
		termsAndConditionsURL = WCParamJS.homePageURL+'/terms-of-use';
	} else {
		privacyPolicyURL = WCParamJS.homePageURL+'/privacy-policy';
		termsAndConditionsURL = WCParamJS.homePageURL+'/terms-of-use';
	}
	privacy_options = {
		bipaActive: true,
		region: regionBipa,
		source: 'B2C_RBCOM',
		privacyPolicy: privacyPolicyURL,
		termsAndConditions: termsAndConditionsURL			
	};
	callback_functions = {
		// user can reject our conditions,
		// in this case the exeprience won't begin
		onPrivacyReject:function(e){
			$(".fade-bipa").hide();
			$('.cupertino-pane-wrapper .pane').css('z-index','');
			if(isVogue){
				enableScroll();
			}
			vmSwitchOff(true);
		},
		onPrivacyAgree:function(e){
			//$(".fade-bipa").hide(); HB-12298 
			$('.cupertino-pane-wrapper .pane').css('z-index','');
			if(isVogue){
				enableScroll();
			}
		},
		onPrivacyFail:function(e){
			$(".fade-bipa").hide();
			$('.cupertino-pane-wrapper .pane').css('z-index','');
			if(isVogue){
				enableScroll();
			}
		}
	};
	
	
	initParams['privacy'] = privacy_options;
	initParams['privacyCallbacks'] = callback_functions;
	
	// select the target node
	var target = document.querySelector('#vm_box');
	// create an observer instance
	var observerBipa = new MutationObserver((mutations, observerBipa) => {
		mutations.forEach((mutation) => {
			if (!mutation.addedNodes) return
			    for (let i = 0; i < mutation.addedNodes.length; i++) {
		      // do things to your newly added nodes here
		    	if ($('#BIPA_FORM_SUBTITLE') != null && $('#BIPA_FORM_SUBTITLE').parent() != null) {
		    		$('#BIPA_FORM_SUBTITLE').parent().addClass("line");		    		
		    	}
		    	/*if($('.bipa-overlay').length>0 && isVogue){		    		
		    		//disableScroll();
		    		if($('.ct_show').length > 0 && (window.mobilecheck() || window.tabletPortraitCheck())){
			    		$('.bipa-overlay').css('top', '-23%');	
			    	}else if((window.mobilecheck() || window.tabletPortraitCheck())){
			    		$('.bipa-overlay').css('top', '-10%');	
		    		}
		    	}
		    	*/
		    	//If is PERSOL and the resolution of desktop is 150%
		    	if((isPersol) && $('.bipa-overlay').length>0 && !(window.mobilecheck() || window.tabletPortraitCheck())){
		    		if(window.devicePixelRatio == 1.5){
						$('.bipa-overlay').css('height','auto');
					}
		    	}    	
		    	
				if($('.bipa-overlay').length>0 && (isOliver || isPersol) && (window.mobilecheck() || window.tabletPortraitCheck()) && (regionBipa == 'EU')){
					$('#PRIVACY_FIRST_AGREEMENT').addClass('scrollable_bipa');
					if(isPersol){
						$('#bipa-component-container').css('height','auto');
						$('#bipa-record-consent').css('padding-bottom','0');
						
						/*
						if(iPhoneVersion()=='6-7'){
							$('.bipa-overlay').css('height','172%');  
						}
						
						
						if($("#country").attr('value') == 'DE'){
							$('.scrollable_bipa').css('max-height',$(window).height()*0.13);
						}else{
							$('.scrollable_bipa').css('max-height',$(window).height()*0.2);
						}	
						*/	
					}
				}
        		if ($(mutation.addedNodes[i]).attr("id") == "bipa-form") {
					$('#bipa-notice').niceScroll();
				}
		    }
		})
	});
		observerBipa.observe(target, {
	    childList: true
	  , subtree: true
	  , attributes: false
	  , characterData: false
	});
	

	return initParams;
}

/** Hide VM div and buttons */
function hideVM(closeVM) {
	if (closeVM) {
		vmSwitchOff(false);
	}
	$("#vm_box").addClass("hide");
	$(".btn-vm-hide").hide();
	$("#header").removeClass('vm-active');
	if(!isVogue){
		hideHeaderTimeout.showHeader();
	}	
	$('.popup_link').css('pointer-events', '' );
	$('.owl-buttons').show();
	if(isOliver){
		$(".pdp-fullimage__img").show();
		$('.full-image-widget .owl-controls.clickable').show();
	}else if(isPersol){
		$('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').show();
		$('.full-image-widget .owl-controls.clickable').show();
	}
	if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
  		$("#btn-virtual-mirror").show();
  	}else{
  		$( "#container-btn-dsk" ).show();
  	}
	$("div[id='vm_buttons']").addClass("hide");
	resetVMPosDims();
}

/** Moves VM div over Product div */
function moveVMOverProduct(prod_elem) {
	if (!(window.mobilecheck() || window.tabletPortraitCheck())) {
		if(!isVogue){
			//var prod_div = prod_elem.find(".c-pdp-det__pres-img");
			//var o = prod_div.offset();
			//var prod_div = prod_elem.find(".c-pdp-det__pres-img");
			//var o = prod_div.offset();
			$("#vm_box").css("top", 0);
			// if (isOliver
			// 		&& $.browser.name == "Safari") {
			// 	$("#vm_box").css("top", '-'+$('.pdp-fullimage__carousel').height()+'px');
			// }
			$("#vm_box").css("left", 0);
			$("#vm_box").css("position", 'absolute');
			$("#vm_box").css("margin-left",'32%');
			$("#vm_box").css("width",'35%');
			
			$("#vm_box").css("display",'flex');
			$("#vm_box").css("justify-content",'center');
			if($('.ct-promo-bannerTop.ct-gb--container').length > 0){
				$("#vm_box").css("margin-top",'2.55%');
				$("#vm_box").css("height",$('.full-image-widget').height()*0.94 - $('.ct-promo-bannerTop.ct-gb--container').height());
			}else{
				$("#vm_box").css("margin-top",'1%');
				$("#vm_box").css("height",$('.full-image-widget').height()*0.94);
			}	
		}else{
			$("#vm_box").css("top", $('.widget_product_multiple_image_viewer').offset().top);
			$("#vm_box").css("left",$('.widget_product_multiple_image_viewer').offset().left);
			$("#vm_box").css("position", 'absolute');
			$("#vm_box").css("height",$('.widget_product_multiple_image_viewer').height());
			$("#vm_box").css("width",$('.widget_product_multiple_image_viewer').width());			
		}
		
		$("#vm_box").css("z-index",100);
		$("#vm_target").css("height",'100%');
		$("#vm_target").css("width",'100%');
	} else{	
		$("#vm_box").css("left", 0);
		if(isOliver){
			$("#vm_box").css("width",'100%');
			$("#vm_box").css("z-index",100);
			$("#vm_box").css("height",$('.full-image-widget').height() - $('#header').height());
			$("#vm_box").css("position", 'absolute');
			$("#vm_box").css("top", "0");
			$("#vm_target").css("height",$('.draggable').offset().top-$('.draggable').height());
		}else if (isPersol){
			$("#vm_box").css("width",'100%');
			$("#vm_box").css("height",$('.full-image-widget').height() - $('#header').height());
			$("#vm_box").css("position",'absolute');
			$("#vm_box").css("z-index",25);
			$("#vm_box").css("top",'0px');
			$("#vm_target").css("height",'100%');

		}else if(isVogue){
			$("#vm_box").css("height",$('.square-space-generator').height());
			$("#vm_box").css("width",$('.square-space-generator').width());
			$("#vm_box").css("position", 'absolute');
			$("#vm_box").css("top", $('.full-image-widget').offset().top);	
			$("#vm_box").css("z-index",100);
			$("#vm_target").css("height",'100%');
		}
		$("#vm_target").css("width",'100%');
		
		
	}
}

/** Resets VM div position and dimensions */
function resetVMPosDims() {
	$("#vm_box").removeAttr("style");
	$("#vm_target").removeAttr("style");
}

/** Refreshes VM div with new Product, called whem changing Product */
function refreshVmArea(currentProductId,subProduct) {
	if ($virtualMirrorObj.isVMSupported) {
		var partnumber = subProduct.partNumber;
		var elem = $("div[id='detail_box_content_"+currentProductId+"']");
		if (elem.length != 1) {
			elem = $("div[id='detail_box_content_"+currentProductId+"']:has(.c-prod-det.is-active)");
		}
		$("#vm_box").removeAttr("data-vm");	// Reset partnumber
		if ($.cookie("isVMOpen") == "1") {
			$("button[id='vm_try-them-on']").addClass("hide");	// Hide Try Them On Button
		}
		vmUpcSupportedCallback(partnumber,elem,vmUpcAvailability[partnumber]);
	} else {
		console.error("VM not supported");
		if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
	  		$("#btn-virtual-mirror").hide();
	  	}else{
	  		$( ".container-btn-dsk" ).hide();
	  	}
	}
}

/** Called after UPC supported check */
function vmUpcSupportedCallback(partnumber,elem,response) {
	if (response != undefined
			&& response.available) {
		isUPCSupported = true;
		/* Analytics - Ready virtual mirror 'Try them on' button */
		if($("button[id='vm_try-them-on']").length) {
			try {
				var p;
				if (utag_data.Products !== undefined) {
					p = utag_data.Products[partnumber] || {};
				} else {
					utag_data.Products = {}
					p = utag_data.Products[partnumber] || {};
				}
				p["Vm_IsUpcSupported"] = "1";
				
				tealium_data2track.push({
					id : 'VirtualMirror',
					Vm_Action:'Ready',
					Products:{
						[partnumber]: p
					}
				});
				
				p["Vm_IsUpcSupported"] = "";
				utag_data.Products[partnumber] = p;
			} catch(err) {
				console.log("Error while calling tealium for id=VirtualMirror");
			}
		}
	  // Add VM buttons handlers
	  $(document).off("click","button[id='vm_try-them-on']").on("click","button[id='vm_try-them-on']",vmTryThemOn);
	  $(document).off("click","button[id='vm_switch-off']").on("click","button[id='vm_switch-off']",function() { vmSwitchOff(true); });
	  $(document).off("click","button[id='vm_adjust-to-fit']").on("click","button[id='vm_adjust-to-fit']",vmAdjustToFit);
	  $(document).off("click","button[id='vm_share']").on("click","button[id='vm_share']",vmShare);
	  if (isOliver) {
		$(document).off("click","button[type='button'][id='savePhoto']").on("click","button[type='button'][id='savePhoto']",vmSave);
	  }
	  moveVMOverProduct(elem);
	  $("#vm_box").attr("data-vm",partnumber);	// Set partnumber
	  $("div[id='vm_buttons']").removeClass("hide");
	  // If VM yet opened, then switch glasses
	  if ($(".mirror-loader").length > 0
			  || $.cookie("isVMOpen") == "1") {
		if (site_layout == "mobile"/*
				&& $.cookie("isVMOpen") == "1"
				&& $(".mirror-loader").length == 0*/) {
			$("body").scrollTop(1);
			$("div.slick-active .c-prod-det__inner").scrollTop(1);
		}
		vmTryThemOn();
		moveVMOverProduct();
	  }
	  elem.off("vm_resize",vmElemResize).on("vm_resize",vmElemResize);
	} else {
	  isUPCSupported = false;
 	  console.log("UPC "+partnumber+" is not supported by VM");
 	  hideVM(true);
 	  resetVMPosDims();
	}
}

/** Handles VM div dimension on Product image resize */
function vmElemResize(e) {
	var elem = $(e.target);
	if (isVMEnabled()) {
		if (window.matchMedia("(max-width: 1024px)").matches){
			hideVM(true);
		} else {
			var elem = $(".detail_box div");
			moveVMOverProduct(elem);
			if ($(".mirror-loader").length > 0) {
				$("div[id='vm_buttons']").removeClass("hide");
				vmTryThemOn();
				moveVMOverProduct();
			}
		}
	}
}

/** Try Them On button click handler */
function vmTryThemOn(){
	console.log('vmTryThemOn');
	disableOnBlur = true;

	
	
	if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
  		$("#btn-virtual-mirror").hide();
  	}else{
  		$( ".container-btn-dsk" ).hide();
  	}
  if (!(window.mobilecheck() || window.tabletPortraitCheck())) {
	  $("#header").addClass('vm-active');
	  $('.popup_link').css('pointer-events', 'none' );
	  if(isOliver){
		  $(".pdp-fullimage__img").hide();
		  $('.full-image-widget .owl-controls.clickable').hide();
	  }else if(isPersol){
		  $('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').hide();
		  $('.full-image-widget .owl-controls.clickable').hide();
	  }	  
	  $('.owl-buttons').hide();	
	  if(isPersol || isOliver){
		$(".central-image-carousel").css("z-index","4");
	}  
  }else{
	  $('margin-top-short').css('margin-top', '0' );
	  
	  $("#header").addClass('vm-active');
	  if(isPersol){
		  $(".ct-promo-bannerTop").hide();
		  $(".full-image-widget").hide();	
		  $("#other_colors").hide();		  
	  	}
		if(isPersol || isOliver){
			$(".central-image-carousel").css("z-index","4");
			manageStickyElement();
		}
  }
  
  var country = $("#country").attr('value');
  if ($.cookie("ImageConsent") != "true") {
	  //Show bipa fade
	  $(".fade-bipa").show();
  }
  
  var partnumber = $("#vm_box").attr("data-vm");
  if (partnumber != undefined) {
	  // Analytics - data-description with UPC on VM buttons
	  $("a[data-element-id='VirtualMirror_Close']").attr("data-description", partnumber.toString());
	  $("a[data-element-id='VirtualMirror_Screenshot']").attr("data-description", partnumber.toString());
	  $("a[data-element-id='VirtualMirror_Adjust']").attr("data-description", partnumber.toString());
	  
	  $("#vm_box").removeClass("hide");
	  if ((window.mobilecheck() || window.tabletPortraitCheck())) {
		//	Adjust position of buttons
		$("button[id='vm_try-them-on']").addClass("hide");	// Hide Try Them On Button
		$(".c-prod-det__banner div[id='vm_buttons']").remove();
		$("div[id='vm_buttons'] button").each(function(index,element) {
			if ($(this).css("z-index") == "auto") {
				if ($(this).css("bottom") != "auto") {
					$(this).css("bottom",($("div.slick-active .fixed-js-footer").height()+parseFloat($(this).css("bottom")))+"px");
				}
				$(this).css("z-index",1001);
			}
		});

		//We can comment this part, it isn't necessary 
		//	Add Swipe Color for Mobile
		//$(".c-prod-det__inner").css("overflow-y","hidden");
		/*
		if (window.mobilecheck() || window.tabletPortraitCheck()) {
			if (country == 'US' && $.cookie("ImageConsent") != "true") {
				$('.cupertino-pane-wrapper .pane').css('z-index','0');
			}		
			$("#vm_box").swipe({
			  swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
			    if (direction == "up") {
			    	$("div.slick-active .c-modal-colors").find(".c-color-list__item.selected").next().click();
			    } else if (direction == "down") {
			    	$("div.slick-active .c-modal-colors").find(".c-color-list__item.selected").prev().click();
			    } else if (direction == "right") {
			    	vmSwitchOff(false);
			    	$("#vm_box").addClass("hide");
			    	$(".btn-vm-hide").hide();
			    	$("#header").removeClass('vm-active');
			    	if(!isVogue){
			    		hideHeaderTimeout.showHeader();
			  	    }			    	
			    	$('.popup_link').css('pointer-events', '' );
			    	$('.owl-buttons').show();
			    	$("#btn-virtual-mirror-mobile").show();
			    	$(".c-prod-det__banner div[id='vm_buttons']").remove();
			    	$(".pdp-slick-slider").slick("slickPrev");
			    } else if (direction == "left") {
			    	vmSwitchOff(false);
			    	$("#vm_box").addClass("hide");
			    	$(".btn-vm-hide").hide();
			    	$("#header").removeClass('vm-active');
			    	if(!isVogue){
			    		hideHeaderTimeout.showHeader();
			  	    }		
			    	$('.popup_link').css('pointer-events', '' );
			    	$('.owl-buttons').show();
			    	if(isOliver){
			  		  $(".pdp-fullimage__img").show();
			  		$('.full-image-widget .owl-controls.clickable').show();
			  	  	}else if(isPersol){
			  		  $('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').show();
			  		  $('.full-image-widget .owl-controls.clickable').show();
			  	  	}	
			    	$("#btn-virtual-mirror-mobile").show();
			    	$(".c-prod-det__banner div[id='vm_buttons']").remove();
			    	$(".pdp-slick-slider").slick("slickNext");
			    }
			  }
			});
		}*/
	  }
	  //  Enable by cookie
	  $.cookie("isVMOpen", "1", { path: "/", expires : 1 });
	  $.cookie("ModelName", pageSection_2, { path: "/", expires : 1 });
	  //  Render VM
	  
	  try {
		  console.log("-> calling vm render");
		  vmjslib.renderMirror({
		    target: "vm_target",
		    upc: partnumber
		  }).then(function(results) {
			disableOnBlur = false;
	        $(".btn-vm-hide").css('display','block');
	        if (window.mobilecheck() || window.tabletPortraitCheck()) {
	        	if(isVogue){
	        		$('#repositionFrame').css('width',$('#take_photo').width());
	        	}
	    		$("#vm_container").append($("div.slick-active span.js-modal-colors").clone());
	    		$("#vm_container span.js-modal-colors").css("position","absolute");
	    		$("#vm_container span.js-modal-colors").css("right","20px");
	    		$("#vm_container span.js-modal-colors").css("bottom",($("div.slick-active .fixed-js-footer").height()+20)+"px");
	    		$("#vm_container span.js-modal-colors").css("z-index",1001);
	    		$("#vm_container span.js-modal-colors").css("line-height","1.6em");
	    		$("#vm_container span.js-modal-colors").off("click").on("click",function() {
	    			vmSwitchOff(false);
	    	    	$("#vm_box").addClass("hide");
	    	    	$(".btn-vm-hide").hide();
	    	    	$("#header").removeClass('vm-active');
	    	    	if(!isVogue){
			    		hideHeaderTimeout.showHeader();
			  	    }	
	    	    	$('.popup_link').css('pointer-events', '' );
	    	    	if(isOliver){
	    	    		$(".pdp-fullimage__img").show();
	    	    		$('.full-image-widget .owl-controls.clickable').show();
				  	}else if(isPersol){
				  		$('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').show();
				  		$('.full-image-widget .owl-controls.clickable').show();
				  	}
	    	    	$("#btn-virtual-mirror-mobile").show();
	    			$("div.slick-active span.js-modal-colors").click();
	    		});
	    		$(document)
	    				.off("click","div.slick-active .c-modal-colors")
	    				.on("click","div.slick-active .c-modal-colors",function() {
	    			if ($.cookie("isVMOpen") == "1" && $.cookie("ModelName") == pageSection_2 ) {
	    				vmTryThemOn();
	    				moveVMOverProduct();
	    			}else{
	    				vmSwitchOff(true);
	    			}
	    		});
	        }
			$("a[data-element-id='VirtualMirror_Close']").attr("data-description", partnumber.toString());
			$("a[data-element-id='X_Pdp_Vm_TakePhoto']").attr("data-description", partnumber.toString());
			$("#repositionFrame").attr("data-description", partnumber.toString());

		  }).catch(function(error) {
			disableOnBlur = false;
			if (error != undefined) {
			    console.error(error);
			    if (error.type == "UpcMissingError") {
			      console.log("UPC Not Supported: "+partnumber);
			    }
			    if (error.type == "UpcSupportedError") {
				 	//initParams.options.analyticsConfig.onInitializeError("Server","Vm - UpcSupportedError","failed to determine if upc "+partnumber+" is supported",partnumber)
			    }
			    if (error.type == "InvalidParametersError") {
				 	//initParams.options.analyticsConfig.onInitializeError("Client","Vm - InvalidParametersError","parameter is invalid",partnumber)
			    }
			}
			vmSwitchOff(false);
			$("#vm_box").addClass("hide");
			$(".btn-vm-hide").hide();
			$("#header").removeClass('vm-active');
			if(!isVogue){
	    		hideHeaderTimeout.showHeader();
	  	    }	
			$('.popup_link').css('pointer-events', '' );
			$('.owl-buttons').show();
			if(isOliver){
		  		$(".pdp-fullimage__img").show();
		  		$('.full-image-widget .owl-controls.clickable').show();
		  	}else if(isPersol){
		  		$('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').show();
		  		$('.full-image-widget .owl-controls.clickable').show();
		  	}
			if((window.mobilecheck() || window.tabletPortraitCheck()) && !isVogue){
				$("#btn-virtual-mirror-mobile").show();
			}else{
				if(isOliver){
			  		$("#btn-virtual-mirror").show();
			  	}else{
			  		$( "#container-btn-dsk" ).show();
			  	}
			}
			// Remove from cookies
			/*$.cookie("isVMOpen", null, { path: "/"});
			$.cookie("ModelName", null, { path: "/", expires : 1 });*/
		  });
	  } catch (error) {
		  console.error("error calling vm render: "+error);
	  }
	  
	  /* Analytics - 'Try them on' button */
	  tealium_data2track.push({ 
		   id : 'VirtualMirror',
		   Vm_Action : 'TryOn',
		   Products:{
			 	[partnumber]: {
			 		Vm_IsUpcSupported: '1'
			 	}
		   }
	  });  
  }
  
}

/** Switch Off button click handler */
function vmSwitchOff(cleanCookie) {
  $("#vm_box").addClass("hide");
  $(".btn-vm-hide").hide();
  $("#header").removeClass('vm-active');	
  $('.popup_link').css('pointer-events', '' );
  if(isOliver){
	  $(".pdp-fullimage__img").show();
	  $('.full-image-widget .owl-controls.clickable').show();
  }else if(isPersol){
	  $('#owl-pdp .owl-pdp__image-wrapper.glass-img-container').show();
	  $('.full-image-widget .owl-controls.clickable').show();
  }
  if((isOliver || (window.mobilecheck() || window.tabletPortraitCheck())) && !isVogue){
		$("#btn-virtual-mirror").show();
		var timestamp = new Date().getTime() / 1000;
  		var diff = timestamp - renderingPageStarterTime;
  		console.log('TestVM -- show ' + diff.toString().slice(0 , 5) + 's');
	}else{
		$( ".container-btn-dsk" ).show();
		var timestamp = new Date().getTime() / 1000;
  		var diff = timestamp - renderingPageStarterTime;
  		console.log('TestVM -- show ' + diff.toString().slice(0 , 5) + 's');

	}
  $("div[id='vm_buttons']").addClass("hide");
  if (!(window.mobilecheck() || window.tabletPortraitCheck())) {
	  //$("div.detail_box_content .c-pdp-det__left").append($("div[id='vm_buttons']").clone());
	  $("div.detail_box_content .c-pdp-det__left div[id='vm_buttons']").removeClass("hide");
	  $('.owl-buttons').show();
  } else{
	  $(".c-product-carousel-container .slick-active  .c-prod-det__inner .l-footer-no-js, .c-product-carousel-container .slick-active  .c-prod-det__inner .l-footer").append($("div[id='vm_buttons']").clone())
	  $(".detail_box_content .c-prod-det__inner div[id='vm_buttons']").removeClass("hide");
	  if(isPersol){
		  $(".ct-promo-bannerTop").show();
		  $(".long-description-widget").show();
		  $(".full-image-widget").show();	
		  //$("#other_colors").show(); 
		  
	  }
  }
  $("#vm_container span.js-modal-colors").remove();
  $(".c-prod-det__inner").css("overflow-y","visible");

  if((isPersol || isOliver) && cleanCookie){
	$(".central-image-carousel").css("z-index","auto");
	if((window.mobilecheck() || window.tabletPortraitCheck())){
		manageStickyElement();
	}
	
}
  
  //Comment this part, it isn't necessary for HB
  /*if (window.mobilecheck() || window.tabletPortraitCheck()) {
	  $("#vm_box").swipe({
		  swipe: function(event, direction, distance, duration, fingerCount, fingerData) {
		    return false;
		  }
	  });
  }*/
  
  // Remove from cookies
  if (cleanCookie) {
	  $.cookie("isVMOpen", null, { path: "/"});
	  $.cookie("ModelName", null, { path: "/", expires : 1 });
  }
  // Switch off only if VM is opened
  if ($(".mirror-loader").length > 0) {
	try {
     console.log("-> calling vm close");
	 vmjslib.closeMirror({
	   target: "vm_target"
	 }).then(function(results) {
	  $("div[id='vm_buttons'] button").removeAttr("style");
	  $("div.slick-active span.js-modal-colors").css("box-shadow","");
	  $(".c-btn-icon.bottom-right").css("z-index",1002);
	  $(".c-btn-icon.bottom-right").removeClass("hide");
	  $("button[id='vm_switch-off']").addClass("hide");	// Hide Switch Off Button
	  $("button[id='vm_try-them-on']").removeClass("hide");	// Show Try Them On Button
	  $("button[id='vm_adjust-to-fit']").addClass("hide");	// Hide Adjust To Fit Button
	  $("button[id='vm_share']").addClass("hide");	// Hide Share Button
	  //$('.cupertino-pane-wrapper .pane').css('z-index','11'); //re-enable scroll 
	 }).catch(function(error) {
	   console.error(error);
	 });
	} catch (error) {
	 console.error("error calling vm close: "+error);
	}
  }
  resetVMPosDims();
}

/** Adjust To Fit button click handler */
function vmAdjustToFit() {
  // Fit Me Better only if VM is opened
  if ($(".mirror-loader").length > 0) {
	try {
     console.log("-> calling vm fitMeBetter");
     
     /* Analytics - 'Fit Me Better' button */
      var partnumber = $("#vm_box").attr("data-vm");
	  tealium_data2track.push({ 
		   id : 'VirtualMirror',
		   Vm_Action : 'FitGlasses',
		   Products:{
			 	[partnumber]: {
				Vm_IsUpcSupported: '1'
			 	} 
		   }
	  });
     
	 vmjslib.fitMeBetter({
	   target: "vm_target"
	 }).catch(function(error) {
	   console.error(error);
	 });
	} catch (error) {
	 console.error("error calling vm fitMeBetter: "+error);
	}
  }
}

/** Save VM Screenshot */
function vmSave(){
	
	var filter = function(node) {
		return $(node).attr("in_download") != "no";
	}
	if ($.browser.name == "Safari") {
		window.scrollTo(0,0);
		html2canvas(document.querySelector("#vm_dialog"),{
			allowTaint: true,
			useCORS: true
		}).then(canvas => {
			! function(canvas, t) {
				var r = document.createElement("a");
				"string" == typeof r.download ? (r.href = canvas, r.download = t, document.body.appendChild(r), r.click(), document.body.removeChild(r)) : window.open(canvas)
			} (canvas.toDataURL("image/png",0.7),"ShareYourGlasses.png");
			$("#vm_dialog").dialog("close");
			vmSwitchOff(true);
		});
		/*
		function saveAsForVm(uri, filename) {
			var link = document.createElement('a');
			if (typeof link.download === 'string') {
			  link.href = uri;
			  link.download = filename;
			  //Firefox requires the link to be in the body
			  document.body.appendChild(link);
			  //simulate click
			  link.click();
			  //remove the link when done
			  document.body.removeChild(link);
			} else {
			  window.open(uri);
			}
		}
		var canvasOptions = {
            allowTaint: true,
            useCORS: true
            // https://stackoverflow.com/a/54685347
          };
		window.scrollTo(0, 0);
        // Capture only the modal contents only
        html2canvas(document.querySelector("#vm_dialog"), canvasOptions).then(canvas => {
            saveAsForVm(canvas.toDataURL("image/jpeg", 0.7), 'ShareYourGlasses.jpg');
			$("#vm_dialog").dialog("close");
			vmSwitchOff(true);
        });
		*/
		$('.fade-bipa').hide();
	} else {
		
		if (window.mobilecheck() || window.tabletPortraitCheck()) {
			var cloneScreenShot = $('[aria-describedby="vm_dialog"]').clone();			
			cloneScreenShot.addClass('downloadPhoto');
			if (isVogue){
				cloneScreenShot.css('width',$('[aria-describedby="vm_dialog"]').width());
				if(getMobileOperatingSystem() != "iOS"){
					cloneScreenShot.css('margin-left','18%');
					$('.downloadPhoto #vm_dialog').css('width','100%');
				}
			}else if(isPersol){
				cloneScreenShot.css('width','93.5%');
			}else if(isOliver && getMobileOperatingSystem() != "iOS"){
				cloneScreenShot.css('margin-left','5%');
			}
			$('#footer').append(cloneScreenShot[0]);
			domtoimage.toBlob($('.downloadPhoto')[0],{ filter: filter } )
		    .then(function (blob) {	
		    	window.saveAs(blob,"ShareYourGlasses.png");
		    	$('.downloadPhoto').remove();
		   		$("#vm_dialog").dialog("close");
		    	vmSwitchOff(true);
		    	
		    		$('.fade-bipa').hide();
		    	
		    });
		} else{
			disableScroll();
			
			var cloneScreenShot = $('[aria-describedby="vm_dialog"]').clone();			
			cloneScreenShot.addClass('downloadPhoto');
			if (isVogue){
				cloneScreenShot.css('width',$('[aria-describedby="vm_dialog"]').width());
			}else{
				cloneScreenShot.css('width','35%');
			}			
			document.body.appendChild(cloneScreenShot[0]);
			if(isOliver){
				$('.downloadPhoto .ui-dialog-title-vm').css('top',$('.downloadPhoto #vm_screenshot').height());
			}
			domtoimage.toBlob($('.downloadPhoto')[0],{ filter: filter } )
		    .then(function (blob) {
		    	$('.downloadPhoto').remove();
		    	window.saveAs(blob,"ShareYourGlasses.png");
		   		$("#vm_dialog").dialog("close");
		    	vmSwitchOff(true);
		    	enableScroll();
		    	
		    		$('.fade-bipa').hide();
		    	
		    });
		}
	}
}

/** Share button click handler */
function vmShare() {
  // Share only if VM is opened
  if ($(".mirror-loader").length > 0) {
	  
	try {
     console.log("-> calling vm getScreenshot");
	 vmjslib.getScreenshot({
	   target: "vm_target"
	 }).then(function(response) {
		 
		 $("#vm_screenshot").attr("src",response.imgURI);
		 if ($.browser.name == "Safari") {
			 safariScreenshot = response.imgURI;
		 }
		 if (isOliver
				&& $.browser.name == "Safari"
				&& !(window.mobilecheck() || window.tabletPortraitCheck())) {
			$("div[role='dialog']:has(#vm_dialog)").css("top", '-'+$('.pdp-fullimage__carousel').height()+'px');
		 }
	 	 $("#vm_dialog").removeClass("hide");
		 if (!(window.mobilecheck() || window.tabletPortraitCheck())) {
			 $("#vm_screenshot").off("load").on("load",function(){
				 if(isVogue){
					 $("#vm_screenshot").attr("width",$('#vm_target').width()*0.894);
					 $("#vm_screenshot").attr("height",$('#vm_target').height()*0.894); 
				 }else{
					 $("#vm_screenshot").attr("width",$('#vm_target').css('width'));
					 $("#vm_screenshot").attr("height",$('#vm_target').css('height')); 
					 $("#vm_screenshot").css("width",$('#vm_target').css('width'));
					 $("#vm_screenshot").css("height",$('#vm_target').css('height')); 
				 }				 
				 $("#vm_dialog").removeClass("hide");
				 $("#vm_dialog").dialog({
					 modal: true,
					 resizable: false,
					 draggable: false,
					 width: "auto",
				     buttons: [
				        {
				        	text: $('#vm-save-btn').attr('value').toUpperCase(),
				        	id: 'savePhoto',
				        	click: function() {
				                vmSave();
				            }
						}]
				 });
				 
				 if(isPersol){
					 $('[aria-describedby="vm_dialog"]').addClass('vm_screen_container');
					 $('.ui-dialog').css('top','0.9rem');
				 }else if(isOliver){					 
					 $('.ui-dialog').css('left','32.01%');
					 $('.ui-dialog').css('top','1.5rem');
					 $('.ui-dialog').css('z-index','100');
				 }else if(isVogue){
					 $('.ui-dialog').css('left','7%');
					 $('.ui-dialog').css('top','4.5%');
					 $('[aria-describedby="vm_dialog"]').addClass('highlight');
				 }				 
				 $('.ui-dialog').css('background','none');
				 $('.ui-dialog').css('position','fixed');
				 $('.ui-dialog-titlebar').css('border','0');
				 $('.ui-dialog-titlebar').css('padding','0');
				 $('.ui-dialog-title').css('top',$('#vm_screenshot').css('height'));
				 $('.ui-dialog-title').addClass('ui-dialog-title-vm');
				 if($.browser.name != "Safari"){
					 if(!isVogue){
						 $('.ui-dialog-buttonset').attr('in_download','no');
					 }
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('in_download','no');
				 }else{
					 $('.ui-dialog-buttonset').attr('data-html2canvas-ignore','true');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('data-html2canvas-ignore','true');
				 }
				 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('data-analytics_available_call','0');
				 $('.ui-dialog-buttonset').addClass('ui-dialog-buttonset-vm');				 
				 $('#savePhoto').attr('data-element-id', 'X_X_VirtualMirror_SavePhoto');
				 if(isOliver){
					 $('.ui-dialog-titlebar .ui-button').empty();					 
					 $('.ui-dialog-titlebar .ui-button').css({
						 	'width': 'auto',
							'position': 'absolute',
						    'right': '2rem',
						    'top': '3rem',
						    'cursor': 'pointer',
						    'padding': '0.5rem',
						    'padding-top': '0rem',
						    'border-radius': '100%',
						    'background-color': '#f8f8fb',
						 });
					 $('.ui-dialog-titlebar .ui-button').addClass('btn-dialog-vm');
				 }else if (isPersol){
					 $('.ui-dialog-titlebar .ui-button').empty();
					 $('.ui-dialog-titlebar .ui-button').addClass('closeScreen');					 
				 }else if (isVogue){
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').text('');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').css({
							'position': 'absolute',
						    'right': '1rem',
						    'top': '1rem',
						    'cursor': 'pointer',
						    'border-radius': '100%',
						    'background-color': '#fff',
						    'border': '1px solid #fff',
						    'background-image': 'url(/wcsstore/VogueSAS/images/svg/close-dark.svg)',
						    'background-repeat': 'no-repeat',
						    'background-position': '3.5px 3.5px',
						    'background-size': '13px'
						    	
					 });
				 }	 
				 $('.banner').hide();
				 $('.ui-button-icon').addClass('btn-dialog-vm');
				 var currentColor = $('.current-product-colors').text();
				 var modelName;
				 if(isOliver){
					 modelName = $('.product_text--title h1').text();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title').empty();
					 $('#logoShot').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title').append('<div id="logoShot"><div class="logo_op"></div></div>');
					 $('#typeFrame').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function(){$('.fade-bipa').hide()});	
					 if($('.colorFrame').offset().left + $('.colorFrame').width() > $('#savePhoto').offset().left){
						 //$('#savePhoto').css('height',  $('#savePhoto').outerHeight() + 12);
						 $('.ui-dialog-buttonset-vm').css('margin-top', '2%');
						 $('.ui-dialog-buttonset-vm').css('height',  $('.ui-dialog-buttonset-vm').outerHeight() + 9);						 
						 $('.colorFrame').css('max-width', '14vw');
						 //$('#logoShot').css('height', '85%');
						 //$('#logoShot').css('top', '28%');						 
					 }
				 }else if(isPersol){
					 modelName = $('.persol-product-title').text();
					 $('#logoShot').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title-vm').append('<div id="logoShot"><div class="logo_po"></div></div>');
					 $('#typeFrame').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title-vm').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function(){$('.fade-bipa').hide()});
				}else if(isVogue){					 	
					 modelName = $('.model-name.product__name')[0].textContent;
					 currentColor = $('.front-color')[0].textContent + ' ' + $('.lens-color')[0].textContent;
					 $('[data-element-id="X_X_VirtualMirror_SavePhoto"]').click(function() {enableScroll()});
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function() {enableScroll();$('.fade-bipa').hide();vmTryThemOn();moveVMOverProduct();});
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title').empty();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-title').empty();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-buttonset-vm').append('<div id="logoShot"><div class="logo_vo"></div></div>');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-buttonset-vm').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('#savePhoto').attr("in_download", 'no');					 
					 $('[aria-describedby="vm_dialog"] [title="Close"]').attr("in_download", 'no');
					 if($('.colorFrame').offset().left + $('.colorFrame').width() > $('#savePhoto').offset().left){
						 $('#savePhoto').css('top',  '31%');
						 $('.ui-dialog-buttonset-vm').css('height',  $('.ui-dialog-buttonset-vm').outerHeight() + 9);						 
						 $('.colorFrame').css('max-width', '54%');
					 }
					 vmSwitchOff(false);
				 }
				
				 	 
			  });
		 } else{
			 
			 $("#vm_screenshot").off("load").on("load",function(){
				 $("#vm_dialog").removeClass("hide");
				 $("#vm_screenshot").css("width",response.width*0.85);
				 $("#vm_screenshot").css("height",response.height*0.88);
				 if (isPersol){
					 $('[aria-describedby="vm_dialog"]').css('top','2.5rem')
				 }
				 $("#vm_dialog").dialog({
					 modal: true,
					 resizable: false,
					 draggable: false,
					 width: "auto",
				     buttons: [
				        {
				        	text: $('#vm-save-btn').attr('value').toUpperCase(),
				        	id: 'savePhoto',
				        	click: function() {
				                vmSave();
				            }
						}]
				 });
				 if($.browser.name != "Safari"){
					 if(!isVogue){
						 $('.ui-dialog-buttonset').attr('in_download','no');
					 }					 
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('in_download','no');
				 }else{
					 $('.ui-dialog-buttonset').attr('data-html2canvas-ignore','true');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('data-html2canvas-ignore','true');
				 }
				 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar [title="Close"]').attr('data-analytics_available_call','0');
				 if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
					$(".ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close").text("");
				 }
				 $("#vm_dialog .banner").hide();
				 $('#savePhoto').attr('data-element-id', 'X_X_VirtualMirror_SavePhoto');
				 var currentColor = $('.current-product-colors').text();
				 var modelName;
				 if (isOliver){
					 modelName = $('.product_text--title h1').text();
					 $('#typeFrame').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-buttonpane').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function(){$('.fade-bipa').hide()});
				}else if (isPersol){
					 modelName = $('.persol-product-title').text();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar-close').addClass('closeScreen');
					 $('#typeFrame').remove();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-buttonpane').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function(){$('.fade-bipa').hide()});
				 }else if(isVogue){
					 $('[data-element-id="X_X_VirtualMirror_SavePhoto"]').click(function() {enableScroll()});
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').click(function() {enableScroll();$('.fade-bipa').hide();});
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').text('');
					 $('[aria-describedby="vm_dialog"] .ui-dialog-titlebar .ui-button').css({
							'position': 'absolute',
						    'right': '1.8rem',
						    'top': '0.6rem',
						    'cursor': 'pointer',
						    'border-radius': '100%',
						    'background-color': '#fff',
						    'border': '1px solid #fff',
						    'background-image': 'url(/wcsstore/VogueSAS/images/svg/close-dark.svg)',
						    'background-repeat': 'no-repeat',
						    'background-position': '3.5px 3.5px',
						    'background-size': '13px'
						    	
					 });
					 $('[aria-describedby="vm_dialog"]').css('top',$('.header__content').height() + $('.header__content').offset().top );
					 modelName = $('.model-name.product__name')[0].textContent;
					 currentColor = $('.front-color')[0].textContent + ' ' + $('.lens-color')[0].textContent;
					 //$('[aria-describedby="vm_dialog"] .ui-dialog-title').empty();
					 $('[aria-describedby="vm_dialog"] .ui-dialog-buttonset').append('<div id="typeFrame"><span class="modelName">'+ modelName+'</span><span class="colorFrame">'+ currentColor +'</span></div>');
					 $('#savePhoto').attr("in_download", 'no');					 
					 $('[aria-describedby="vm_dialog"] [title="Close"]').attr("in_download", 'no');
					 $(".ui-dialog-buttonpane").css("width",$('#vm_screenshot').css('width'));
					 if($('.colorFrame').offset().left + $('.colorFrame').width() > $('#savePhoto').offset().left){
						 $('#savePhoto').css('top',  '38%');						 						 
						 $('.colorFrame').css('max-width', '195px');
					 }
				 }
				 
			 });
		 }
		 
	 }).catch(function(error) {
	   console.error(error); 
	 });
	} catch (error) {
	 console.error("error calling vm getScreenshot: "+error);
	}
  }

  if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
	$(".ui-button.ui-corner-all.ui-widget.ui-button-icon-only.ui-dialog-titlebar-close").text("");
  }
}

/** Handle events on window inactive, scroll, vertical swipe */
function vmHandleEventsOnPage() {
		//	Disable VM on window inactive
		if ($.browser.name != "Safari"
			|| ((window.mobilecheck() || window.tabletPortraitCheck()) && getMobileOperatingSystem() != 'iOS')) {
			$(window).on("blur focus", function(e) {
				var prevType = $(this).data("prevType");
				if (prevType != e.type) {   //  reduce double fire issues
					if ($.cookie("isVMOpen") == "1" && $.cookie("ModelName") == pageSection_2 ) {
						switch (e.type) {
							case "blur":
								if (!disableOnBlur) {
									vmSwitchOff(false);
								}
								break;
							case "focus":
								if(isOliver && (window.mobilecheck() || window.tabletPortraitCheck())){
									if ($(".mirror-loader").length == 0) {
										vmTryThemOn();
										moveVMOverProduct();
									}
								}else if(isPersol && (window.mobilecheck() || window.tabletPortraitCheck())){
									if ($(".mirror-loader").length == 0){
										vmTryThemOn();
										moveVMOverProduct();
									}
								}else if(isOliver && !(window.mobilecheck() || window.tabletPortraitCheck())){
									if ($("#pdp_other_colors").isInViewport()
											&& $(".mirror-loader").length == 0){
										vmTryThemOn();
										moveVMOverProduct();
									}
								}else if(isPersol && !(window.mobilecheck() || window.tabletPortraitCheck())){
									if ($("#pdp_other_colors").isInViewport()
											&& $(".mirror-loader").length == 0){
										vmTryThemOn();
										moveVMOverProduct();
									}
								}else if (isVogue && (window.mobilecheck() || window.tabletPortraitCheck())){
									if ($(".square-space-generator").isInViewport()) {
					    				if ($(".mirror-loader").length == 0) {
								    		vmTryThemOn();
								    		moveVMOverProduct();
								    	}
					    			}
								}else if(isVogue && !(window.mobilecheck() || window.tabletPortraitCheck())){
									if ($('#colors-desktop').isInViewport()){
										if ($(".mirror-loader").length == 0) {
								    		vmTryThemOn();
								    		moveVMOverProduct();
								    	}
									}
								} 
								break;
						}
					} else if (safariScreenshot != undefined
						&& e.type == "focus") {	// Come back from Safari screenshot
						//  Enable by cookie
						$.cookie("isVMOpen", "1", { path: "/", expires : 1 });
						safariScreenshot = undefined;
					}else{
						vmSwitchOff(true);
					}
				}
				$(this).data("prevType",e.type);
			});
		}else if( $.browser.name == "Safari" || (getMobileOperatingSystem() == 'iOS'
			&& (window.mobilecheck() || window.tabletPortraitCheck()))){
			document.addEventListener("visibilitychange", function() {
				if ($.cookie("isVMOpen") == "1" && $.cookie("ModelName") == pageSection_2 ) {
					if (document.hidden){
						if (!disableOnBlur) {
							vmSwitchOff(false);
						}
				    } else {
				    	if(isOliver){
							if (myPane.currentBreak() == 'bottom'
									&& $(".mirror-loader").length == 0) {
								vmTryThemOn();
								moveVMOverProduct();
							}
						}else if(isPersol){
							if (myPane.currentBreak() == 'bottom'
									&& $(".mirror-loader").length == 0){
								vmTryThemOn();
								moveVMOverProduct();
							}
						}else if(isVogue){
							if ($(".square-space-generator").isInViewport()) {
			    				if ($(".mirror-loader").length == 0) {
						    		vmTryThemOn();
						    		moveVMOverProduct();
						    	}
			    			}
						}
				    }
				}
			});
		}
	
	if ($.cookie("isVMOpen") == "1" && $.cookie("ModelName") == pageSection_2) {
		moveVMOverProduct();
		vmTryThemOn();
	}else{
		vmSwitchOff(true);
	}
	
	
	if (!(window.mobilecheck() || window.tabletPortraitCheck())) {
		if(isOliver){
			$(window).on("resize",function() {
				calculateDistances();
			});
		}
		//Handle visibility of VM on scroll (Desktop only)
		$(window).on("resize scroll",function() {
			if ($.cookie("isVMOpen") == "1") {
				if(isOliver){
					if ($("#pdp_other_colors").isInViewport()) {
				    	if ($(".mirror-loader").length == 0) {
				    		vmTryThemOn();
				    		moveVMOverProduct();
				    	}
				    } else {
				    	vmSwitchOff(false);
				    }
				}else if(isPersol){
					if ($("#other_colors").isInViewport()) {
				    	if ($(".mirror-loader").length == 0) {
				    		vmTryThemOn();
				    		moveVMOverProduct();
				    	}
				    } else {
				    	vmSwitchOff(false);
				    }
				}else if(isVogue){
					if ($('#colors-desktop').isInViewport()){
						if ($(".mirror-loader").length == 0) {
				    		vmTryThemOn();
				    		moveVMOverProduct();
				    	}
					}else{
						vmSwitchOff(false);
					}
				}
			    
			}
		});
	}
	//	Show or Hide Swipe to change banner (Mobile only)
	if (window.mobilecheck() || window.tabletPortraitCheck()) {
	    new MutationObserver(function(mutationsList) {
	        for (var i = 0; i < mutationsList.length; i++) {
	        	for (var j = 0; j < mutationsList[i].addedNodes.length; j++) {
	        		if ($(mutationsList[i].addedNodes[j]).hasClass("nudging-guide")
	        				&& !$(mutationsList[i].addedNodes[j]).hasClass("swipe-to-change")) {
	        			$("#vm_target .nudging-guide.swipe-to-change").remove();
				        var observer = new MutationObserver(function(mutationsList, observer) {
				            for (var mutation of mutationsList) {
				            	for (var removed of mutation.removedNodes) {
				            		if ($(removed).hasClass("nudging-guide")
				            				&& !$(removed).hasClass("swipe-to-change")) {
				            			//	Add Swipe to change banner
				            			var swipeToChange = $(".nudging-guide.swipe-to-change").clone();
				            			swipeToChange.insertAfter($(mutation.target));
				            			swipeToChange.removeClass("hide");
				            			swipeToChange.css("display","block","important");
				            			observer.disconnect();
				            			break;
				            		}
				            	}
				            }
				        }).observe(
				        		document.querySelector("#vm_target"),
				        		{ attributes: false, childList: true, subtree: true }
				        );
	        			break;
	        		}
	        	}
	        }
	    }).observe(document.querySelector("#vm_target") || document, {
	        subtree: true,
	        childList: true,
	    });
	    
	    if(isVogue){
	    	$(window).on("resize scroll",function() {
	    		if ($.cookie("isVMOpen") == "1") {
	    			if ($(".square-space-generator").isInViewport()) {
	    				if ($(".mirror-loader").length == 0) {
				    		vmTryThemOn();
				    		moveVMOverProduct();
				    	}
	    			}else{
	    				vmSwitchOff(false);
	    			}
	    		}
	    	});
	    }
	}
}

/** Handle push of Analytics for VM */
function vmPdpAnalytics(callback) {
	$.when(all(vmPartnumberArr,vmCatalogue.isUpcSupported(...vmPartnumberArr)))
	  .then(function(allUPCSupported) {
		  callback(allUPCSupported);
	  });
}

/** Handle VM height on mobile */
function vmAdjustMobileHeight(h) {
	if (site_layout == "mobile") {
		if ($.cookie("isVMOpen") == "1") {
	    	$(".c-prod-det__banner").css("height",h);
	    	if (!$("div.slick-active .c-modal-colors").is(":visible")) {
	    		$(".c-prod-det__banner").css("z-index",1000);
	    	} else {
	    		$(".c-prod-det__banner").css("z-index","");
	    	}
	    } else {
	    	$(".c-prod-det__banner").css("height","");
	    	$(".c-prod-det__banner").css("z-index","");
	  	    if ($(window).scrollTop() <= 1) {
	  			var innerHeight = $.browser.name == "Safari" ? $(window).innerHeight() : window.innerHeight;
				$("div.slick-active .l-footer").css("bottom","auto");
			  	$("div.slick-active .l-footer").css("top",
			  			Math.min(innerHeight-$("div.slick-active .fixed-js-footer").height(),
							$("div.slick-active .c-prod-det__banner").height())
			  			-$("div.slick-active .js-modal-colors").height()-30+"px");
			  	$("div.slick-active div[id='vm_buttons']").css("position","absolute");
				$("div.slick-active div[id='vm_buttons']").css("bottom","auto");
				$("div.slick-active div[id='vm_buttons']").css("top",
					Math.min(innerHeight-$("div.slick-active .fixed-js-footer").height(),
							$("div.slick-active .c-prod-det__banner").height())
						-$("div.slick-active .js-modal-colors").height()+22+"px");
		  	}
	    }
	}
}

$.fn.isInViewport = function() {
    var elementTop = $(this).offset().top;
    var elementBottom = elementTop + $(this).outerHeight();

    var viewportTop = $(window).scrollTop();
    var viewportBottom = viewportTop + $(window).height();

    return elementBottom > viewportTop && elementTop < viewportBottom;
};

function getMobileOperatingSystem() {
    var userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        return "Android";
    }

    // iOS detection from: http://stackoverflow.com/a/9039885/177710
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        return "iOS";
    }

    return "unknown";
}


function iPhoneVersion() {
	  var iHeight = window.screen.height;
	  var iWidth = window.screen.width;

	  
	  if (iWidth === 390 && iHeight === 844) {
		    return "12-13";
	  }
	  
	  if (iWidth === 414 && iHeight === 896) {
		    return "11";
	  }

	  if (iWidth === 414 && iHeight === 896) {
	    return "Xmax-Xr";
	  }
	  else if (iWidth === 375 && iHeight === 812) {
	    return "X-Xs";
	  }
	  else if (iWidth === 320 && iHeight === 480) {
	    return "4";
	  }
	  else if (iWidth === 375 && iHeight === 667) {
	    return "6-7";
	  }
	  else if (iWidth === 414 && iHeight === 736) {
	    return "6+";
	  }
	  else if (iWidth === 320 && iHeight === 568) {
	    return "5";
	  }
	  else if (iHeight <= 480) {
	    return "2-3";
	  }
	  return 'none';
}

